var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJobCreated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2V6H12V2H8ZM6.5 0C6.22386 0 6 0.223858 6 0.5V7.5C6 7.77614 6.22386 8 6.5 8H9V10H3C2.44771 10 2 10.4477 2 11L2 11.0009L2 14C2 14.0565 2.00469 14.1119 2.0137 14.1659C0.841357 14.5738 0 15.6887 0 17C0 18.6569 1.34315 20 3 20C4.65685 20 6 18.6569 6 17C6 15.6887 5.15864 14.5738 3.9863 14.1659C3.99531 14.1119 4 14.0565 4 14L4 12H9V14C9 14.0565 9.00469 14.1119 9.0137 14.1659C7.84136 14.5738 7 15.6887 7 17C7 18.6569 8.34315 20 10 20C11.6569 20 13 18.6569 13 17C13 15.6887 12.1586 14.5738 10.9863 14.1659C10.9953 14.1119 11 14.0565 11 14V12H16V14C16 14.0565 16.0047 14.1119 16.0137 14.1659C14.8414 14.5738 14 15.6887 14 17C14 18.6569 15.3431 20 17 20C18.6569 20 20 18.6569 20 17C20 15.6887 19.1586 14.5738 17.9863 14.1659C17.9953 14.1119 18 14.0565 18 14V11C18 10.4477 17.5523 10 17 10H11V8H13.5C13.7761 8 14 7.77614 14 7.5V0.5C14 0.223858 13.7761 0 13.5 0H6.5ZM4 17C4 17.5523 3.55228 18 3 18C2.44772 18 2 17.5523 2 17C2 16.4477 2.44772 16 3 16C3.55228 16 4 16.4477 4 17ZM18 17C18 17.5523 17.5523 18 17 18C16.4477 18 16 17.5523 16 17C16 16.4477 16.4477 16 17 16C17.5523 16 18 16.4477 18 17ZM10 18C10.5523 18 11 17.5523 11 17C11 16.4477 10.5523 16 10 16C9.44772 16 9 16.4477 9 17C9 17.5523 9.44772 18 10 18Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobCreated);
export default __webpack_public_path__ + "static/media/job_created.aa70e36956eca2847e12b66145368af0.svg";
export { ForwardRef as ReactComponent };